import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { createStackNavigator } from "@react-navigation/stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export const WorkspaceTodoStack =
  createStackNavigator<WorkspaceTodoEditStackParamList>();

type WorkspaceTodoEditStackParamList = {
  WorkspaceTodoEditMain: {
    id: string;
    workspaceId: string;
    create?: boolean;
    parentId?: string;
  };
};

export type WorkspaceTodoEditNavigationProp<
  T extends keyof WorkspaceTodoEditStackParamList,
> = CompositeNavigationProp<
  NativeStackNavigationProp<WorkspaceTodoEditStackParamList, T>,
  UserLoggedInNavigatorNavigationProp<"WorkspaceTodoEdit">
>;

export type WorkspaceTodoEditRouteProp<
  T extends keyof WorkspaceTodoEditStackParamList,
> = RouteProp<WorkspaceTodoEditStackParamList, T>;
